<div class="kendo-textbox" [formGroup]="parentForm">
  <kendo-formfield>
    <kendo-floatinglabel text={{inputText}}>
      <kendo-textbox 
        #textbox
        class="k-floating-label-container k-empty"
        [value]="autofillValue"
        [formControlName]="formControlName"
        [maxlength]="maxLength"
        (keydown)="this.typing()"
      >
      </kendo-textbox>
    </kendo-floatinglabel>
  </kendo-formfield>
</div>